import Vue from 'vue'
import { mapState } from 'vuex'
import CustomerProfile from './CustomerProfile/CustomerProfile.vue'
import FreelancerProfile from './FreelancerProfile/FreelancerProfile.vue'
import { DASHBOARD, PROFILE_SETTINGS } from '@/constants/routes'
import rolebleMixin from '@/mixins/rolebleMixin'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'

export default Vue.extend<any, any, any, any>({
  mixins: [rolebleMixin, unreadMessagesBlinkTitleMixin],
  components: {
    FreelancerProfile,
    CustomerProfile,
  },
  data() {
    return {
      DASHBOARD,
      PROFILE_SETTINGS,
    }
  },
  computed: {
    ...mapState('user', {
      userInfoLoaded: (state: any) => state.profile.isLoaded,
      userInfoLoading: (state: any) => state.profile.isLoading,
    }),
    isLoaded() {
      return this.activeRole && !this.userInfoLoading
    },
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('Profile'),
    }
  },
})
